import styled from 'styled-components';

export const Item = styled.li`
display: flex;
align-items: center;
justify-content: space-between;

`;